var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.carousel.type === "Quote Slider"
    ? _c("QuoteSlider", { attrs: { slides: _vm.carousel.slides } })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }